<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>老师请假列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="8">
            <Form-item label="请假时间">
              <Col span="11">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="请选择日期"
                  @on-change="startTimeDateChange"
                  v-model="queryParam.startTimeDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">-</Col>
              <Col span="11">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="请选择日期"
                  @on-change="endTimeDateChange"
                  v-model="queryParam.endTimeDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="操作人昵称">
              <Input
                placeholder="支持模糊搜索"
                name="adminNickname"
                v-model="queryParam.adminNickname"
              ></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="操作人邮箱">
              <Input
                placeholder="支持模糊搜索"
                name="adminMobile"
                v-model="queryParam.adminMobile"
              ></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="老师ID">
              <Input name="tchId" v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="老师姓名">
              <Input
                placeholder="支持模糊搜索"
                name="tchName"
                v-model="queryParam.tchName"
              ></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="老师账号">
              <Input
                placeholder="支持模糊搜索"
                name="tchEmail"
                v-model="queryParam.tchEmail"
              ></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="外教运营">
              <Select
                v-model.number="queryParam.studyAdviserId"
                placeholder="全部"
                @on-change="search"
                clearable
              >
                <Option
                  v-for="item in studyAdviserList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.nickname }}
                </Option
                >
              </Select>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="请假类型">
              <Select v-model="queryParam.leaveType" transfer clearable>
                <Option
                  v-for="item in $constant.tchLeaveType"
                  :value="item.code"
                  :key="item.code"
                >{{ item.text }}
                </Option
                >
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="btn-container">
      <Row>
        <Button
          type="primary"
          :loading="searchLoading"
          :disable="searchLoading"
          icon="search"
          @click="search"
        >搜索
        </Button>
        <Button
          type="primary"
          :loading="exportLoading"
          :disable="exportLoading"
          icon="search"
          @click="exportData"
        >导出
        </Button>
      </Row>
    </div>

    <Modal width="1050" title="修改请假时间" v-model="showModifyLeaveTimeModal">
      <Form
        ref="modifyTimeForm"
        :label-width="60"
        v-model="leaveTimeChangeParam"
        :rules="modifyLeaveTimeRule"
      >
        <Table
          class="compact"
          size="small"
          :columns="tchLeaveLessonColumn"
          :data="bookLessonOpenedList"
        ></Table>
        <Row><br/></Row>
        <Row>
          备注：若修改的时间不影响请假课程的可以直接修改，若影响到了课程的请联系技术人员修改！！！
        </Row
        >
        <Row><br/></Row>
        <Form-item label="请假结束时间修改:" :label-width="120">
          <Row>
            <Col span="6" style="text-align: right">
              <Date-picker
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="开始时间"
                v-model="leaveTimeChangeParam.startLeaveTimeDate"
                disabled
              ></Date-picker>
            </Col>
            <Col span="2" style="text-align: center">-</Col>
            <Col span="6" style="text-align: left">
              <Form-item prop="endTime">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="修改结束日期"
                  @on-change="newEndLeaveTimeChange"
                  v-model="leaveTimeChangeParam.endLeaveTimeDate"
                ></Date-picker>
              </Form-item>
            </Col>
          </Row>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button
          type="text"
          size="large"
          @click="showModifyLeaveTimeModal = false"
        >取消
        </Button
        >
        <Button type="primary" size="large" @click="onModifyLeaveEndTime"
        >确认修改
        </Button
        >
      </div>
    </Modal>

    <List
      ref="dataList"
      :tableColumns="title"
      :reload="reload"
      listUrl="/bookTchLeaveTime/list"
      :params="queryParam"
      :onLoading="onLoading"
      operator=""
    ></List>
    <TchLeaveLessonModal
      v-model="showTchLeaveLessonModal"
      :tchId="tchLeaveLessonParam.tchId"
      :startTime="tchLeaveLessonParam.startTime"
      :endTime="tchLeaveLessonParam.endTime"
      :lsnSelStatus="tchLeaveLessonParam.lsnSelStatus"
    ></TchLeaveLessonModal>
    <tch-info-modal
      :value="showTchInfoModal"
      @on-close="showTchInfoModal = false"
      :tchId="tchId"
      :successCallback="search"
    ></tch-info-modal>

    <Modal title="编辑请假类型" v-model="editModal">
      <Form
        ref="leaveForm"
        class="form"
        :label-width="80"
        :model="leaveParam"
        :rules="leaveRule"
      >
        <Row>
          <Col span="4">
            <FormItem label="请假类型：">
              <Select v-model="leaveType" style="width: 180px">
                <Option
                  v-for="item in $constant.tchLeaveType"
                  :value="item.code"
                  :key="item.code"
                >{{ item.text }}
                </Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal = false"
        >取消
        </Button
        >
        <Button type="primary" size="large" :loading="loadingEdit" @click="edit"
        >保存
        </Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import TchLeaveLessonModal from './TchLeaveLessonModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {TchLeaveLessonModal, TchInfoModal},
  data() {
    let $constant = this.$constant
    let $moment = this.$moment
    let self = this
    return {
      editModal: false,
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      exportLoading: false,
      reload: 0,
      leavlId: null,
      leaveType: null,
      showTchInfoModal: false,
      tchId: null,
      showModifyLeaveTimeModal: false,
      leaveTimeChangeParam: {
        startLeaveTimeDate: '',
        endLeaveTimeDate: '',
        startLeaveTime: 0,
        endLeaveTime: 0,
        leaveType: null,
        endTime: 0,
        maxLeaveLessonTime: 0,
      },
      bookLessonOpenedList: [],
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        leaveType: null,
      },
      studyAdviserList: [],
      modifyLeaveTimeRule: {
        endTime: [
          {
            validator(rule, value, callback, source, options) {
              let errors = []
              if (!self.leaveTimeChangeParam.endTime) {
                errors.push('选择的时间不能为空！')
                callback(errors)
                return
              }
              if (
                self.leaveTimeChangeParam.endTime * 1000 <
                new Date().getTime()
              ) {
                errors.push('所选时间不能小于当前时间！')
                callback(errors)
                return
              }
              if (
                self.leaveTimeChangeParam.endTime <
                self.leaveTimeChangeParam.maxLeaveLessonTime
              ) {
                errors.push(
                  '所选时间不能小于：' +
                  self.$moment(
                    self.leaveTimeChangeParam.maxLeaveLessonTime,
                    'X'
                  ).format('YYYY-MM-DD HH:mm')
                )
                callback(errors)
                return
              }
              if (
                self.leaveTimeChangeParam.endTime >
                self.leaveTimeChangeParam.endLeaveTime
              ) {
                errors.push(
                  '所选时间不能大于：' +
                  self.$moment(self.leaveTimeChangeParam.endLeaveTime, 'X').format('YYYY-MM-DD HH:mm')
                )
                callback(errors)
                return
              }
              callback(errors)
            },
          },
        ],
      },
      tchLeaveLessonColumn: [
        {
          title: '学生ID、姓名',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('span', row.uid),
              h('br', '  '),
              h('span', row.userNickname || ''),
            ])
          },
        },
        {
          title: '老师ID、姓名',
          width: 180,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
              score: row.monthRankScore,
              onClick: row.tchId ? () => this.openTchInfoModal(row.tchId) : null
            })
          },
        },
        {
          title: '老师账号',
          width: 100,
          key: 'tchEmail',
        },
        {
          title: '外教运营',
          width: 90,
          key: 'tchStudyAdviserNickname',
        },
        {
          title: '学顾',
          width: 90,
          key: 'studyAdviserNickname',
        },
        {
          title: '课程类型',
          align: 'center',
          width: 72,
          render: (h, params) => {
            let lsnType = params.row.lsnType
            let typeEnum = $constant.getEnum(
              $constant.bookLessonOpenedLsnType,
              lsnType
            )
            return h('span', typeEnum && typeEnum.text)
          },
        },
        {
          title: '课程名称',
          key: 'lessonTitle',
        },
        {
          title: '开始、结束时间',
          align: 'center',
          width: 122,
          render: (h, params) => {
            let lsnBeginTime = params.row.lsnBeginTime
            let lsnEndTime = params.row.lsnEndTime
            return h(
              'span',
              $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') +
              ' ' +
              $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm')
            )
          },
        },
        {
          title: '上课时长',
          align: 'center',
          width: 72,
          key: 'courseTime',
        },
        {
          title: '上课状态',
          width: 72,
          render: (h, params) => {
            let lsnSelStatus = params.row.lsnSelStatus
            let statusEnum = $constant.getEnum(
              $constant.lsnSelStatus,
              lsnSelStatus
            )
            return h('span', statusEnum && statusEnum.text)
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 72,
          render: (h, params) => {
            let btns = []
            let now = new Date().getTime()
            let startTime = params.row.lsnBeginTime
            if (now / 1000 < startTime) {
              btns.push(
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.onCancelLesson(params.row)
                      },
                    },
                  },
                  '取消'
                )
              )
            }
            return h('div', [btns])
          },
        },
      ],
      showTchLeaveLessonModal: false,
      tchLeaveLessonParam: {},
      title: [
        {
          title: '老师姓名',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.tchId)
            })
          },
        },
        {
          title: '老师账号',
          key: 'tchEmail',
          width: 130,
          align: 'center',
        },
        {
          title: '开始、结束时间',
          align: 'center',
          width: 170,
          render: (h, params) => {
            let startTime = params.row.startTime
            let endTime = params.row.endTime
            return h(
              'span',
              $moment(startTime, 'X').format('YYYY-MM-DD HH:mm:ss') +
              ' ' +
              $moment(endTime, 'X').format('YYYY-MM-DD HH:mm:ss')
            )
          },
        },
        {
          title: '涉及课节',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h(
                'a',
                {
                  on: {
                    click: () => {
                      this.onTchLeaveLesson(row)
                    },
                  },
                },
                '查看'
              ),
            ])
          },
        },
        {
          title: '涉及节数',
          width: 100,
          align: 'center',
          key: 'touchClassNum',
        },
        {
          title: '操作人',
          width: 100,
          key: 'adminNickname',
        },
        {
          title: '所属外管',
          width: 100,
          key: 'studyAdviserNickname',
        },
        {
          title: '操作时间',
          align: 'center',
          width: 170,
          render: (h, params) => {
            let updateTime = params.row.updateTime
            return h(
              'span',
              updateTime &&
              $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss')
            )
          },
        },
        {
          title: '请假原因分类',
          width: 150,
          align: 'center',
          key: 'remarkType',
        },
        {
          title: '请假原因',
          width: 150,
          align: 'center',
          key: 'remark',
        },
        {
          title: '请假类型',
          width: 270,
          align: 'center',
          render: (h, params) => {
            let tchLeaveType = params.row.leaveType
            let tchLeaveTypeEnum = $constant.getEnum(
              $constant.tchLeaveType,
              tchLeaveType
            )
            return h('div', tchLeaveTypeEnum && tchLeaveTypeEnum.text)
          },
        },
        {
          title: '状态',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let status = params.row.status
            let statusEnum = $constant.getEnum(
              $constant.tchLeaveStatus,
              status
            )
            return h('span', statusEnum && statusEnum.text)
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          render: (h, params) => {
            let btns = [
              h(
                'a',
                {
                  on: {
                    click: () => {
                      this.onEdit(params.row)
                    },
                  },
                },
                '修改请假类型'
              ),
            ]
            btns.push(h('span', ' | '))
            let status = params.row.status
            let startTime = params.row.startTime
            let endTime = params.row.endTime
            let now = new Date().getTime()

            if (status === 1 && now / 1000 < startTime) {
              btns.push(
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.onCancel(params.row)
                      },
                    },
                  },
                  '取消'
                )
              )
            }
            if (
              status === 1 &&
              now / 1000 > startTime &&
              now / 1000 < endTime
            ) {
              return h('div', [
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.onModify(params.row)
                      },
                    },
                  },
                  '修改请假时间'
                ),
              ])
            }
            return h('div', [btns])
          },
        },
      ],
    }
  },
  mounted: function () {
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
      self.studyAdviserList = res.data
    })
  },
  created: function () {
    let startTime = this.queryParam.startTime
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
    }
    if (startTime === '') {
      let momentDate = this.$moment().add(-1, 'M')
      momentDate.millisecond(0)
      momentDate.second(0)
      momentDate.minute(0)
      momentDate.hour(0)
      this.queryParam.startTimeDate = momentDate.toDate()
      this.queryParam.startTime = momentDate.format('X')
    }
  },
  methods: {
    onEdit(row) {
      let self = this
      self.leavlId = row.id
      self.leaveType = row.leaveType
      this.editModal = true
    },
    edit() {
      let self = this
      let path = '/bookTchLeaveTime/editType'
      self.$http.post(path, {id: self.leavlId, leaveType: self.leaveType}).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('修改成功!')
          self.editModal = false
          self.search()
        }
      })
    },
    onModifyLeaveEndTime() {
      let self = this
      self.$refs.modifyTimeForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        self.$Modal.confirm({
          title: '提示',
          content: '是否确认修改改请假时间？',
          width: 300,
          okText: '确定修改',
          onOk: () => {
            self.$http.post(
              '/bookTchLeaveTime/modifyEndTime',
              self.leaveTimeChangeParam
            ).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('修改成功!')
                self.showModifyLeaveTimeModal = false
                self.search()
              } else {
                self.$Message.error(res.message)
              }
              self.$Modal.remove()
            })
          },
        })
      })
    },
    onModify(row) {
      let self = this
      self.leavlId = row.id
      self.leaveTimeChangeParam.id = row.id
      self.leaveTimeChangeParam.startLeaveTime = row.startTime
      self.leaveTimeChangeParam.endLeaveTime = row.endTime
      self.leaveTimeChangeParam.startLeaveTimeDate = self.$moment(row.startTime, 'X').format('YYYY-MM-DD HH:mm')
      self.leaveTimeChangeParam.endLeaveTimeDate = self.$moment(row.endTime, 'X').format('YYYY-MM-DD HH:mm')
      self.leaveTimeChangeParam.leaveType = row.leaveType
      let params = {}
      params.tchId = row.tchId
      params.startTime = row.startTime
      params.endTime = row.endTime
      self.$http.get('/bookLesson/tchLeave/list', {params: params}).then(function (res) {
        self.showModifyLeaveTimeModal = true
        self.bookLessonOpenedList = res.data
        for (var j = 0; self.bookLessonOpenedList[j] != null; j++) {
          if (
            self.leaveTimeChangeParam.maxLeaveLessonTime <
            self.bookLessonOpenedList[j].lsnEndTime
          ) {
            self.leaveTimeChangeParam.maxLeaveLessonTime =
              self.bookLessonOpenedList[j].lsnEndTime
          }
        }
      })
    },
    newEndLeaveTimeChange(value) {
      this.leaveTimeChangeParam.endTime =
        value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    openTchInfoModal(val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    search() {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    onTchLeaveLesson(row) {
      this.tchLeaveLessonParam.tchId = row.tchId
      this.tchLeaveLessonParam.startTime = row.startTime
      this.tchLeaveLessonParam.endTime = row.endTime
      this.tchLeaveLessonParam.lsnSelStatus = 6
      this.showTchLeaveLessonModal = true
    },
    // 拆分课程
    onCancelLesson(row) {
      let self = this
      if (!row.id) {
        self.$Message.warning('刷新重新点击')
        return
      }
      if (!self.leavlId) {
        self.$Message.warning('刷新重新点击')
        return
      }
      self.$http.post('/bookTchLeaveTime/splitLeavlTime', {
        openId: row.id,
        leavlId: self.leavlId,
      }).then(function (res) {
        if (res) {
          self.$Message.success('取消成功!')
          self.showModifyLeaveTimeModal = false
          self.search()
        }
      })
      // console.log(row.id)
      // console.log(self.leavlId)
    },
    // 取消请假
    onCancel(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定取消该次请假？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookTchLeaveTime/cancel', {id: row.id}).then(function (res) {
            if (res) {
              self.$Message.success('取消成功!')
              self.search()
            }
            self.$Modal.remove()
          })
        },
      })
    },
    startTimeDateChange(value) {
      this.queryParam.startTime =
        value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime =
        value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    exportData() {
      this.exportLoading = true
      this.$http.get('/bookTchLeaveTime/export', {
        responseType: 'arraybuffer',
        params: this.queryParam,
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '老师请假列表.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
  },
}
</script>


<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// TchLeaveList.vue?42933874